import React, {Component} from "react";
import {Translate} from "react-i18nify";

import * as config from "../../../../constants/config";
import * as settings from "../../../../constants/settings";
import * as resources from "../../../../constants/resources";

export default class ColorantBoxes extends Component {
    sortColorantAlphabetically = () => {
        /* eslint-disable-next-line no-undef */
        let colorantSet = new Map();
        let colorantsNames = [];

        let index = 0;

        let colorantName;
        if (this.props.loggedUser.canRead(resources.COMPONENT_CANISTERS_TAB) && this.props.allowCanisterColorants) {
            let canister;
            for (canister of this.props.canisterList) {
                colorantName = canister.colorant !== null ? canister.colorant.name : "xyz" + index;

                if (!colorantsNames.includes(colorantName)) {
                    colorantsNames.push(colorantName);
                    colorantSet.set(colorantName, this.getColorantBox(canister));
                    index++;
                }
            }
        } else {
            let colorant;
            for (colorant of this.props.colorantList) {
                colorantName = colorant ? colorant.name : "xyz" + index;

                if (!colorantsNames.includes(colorantName)) {
                    colorantsNames.push(colorantName);
                    colorantSet.set(colorantName, this.getColorantBox(null, colorant));
                    index++;
                }
            }
        }

        colorantsNames.sort();

        let sortedElements = [];
        let name;
        for (name of colorantsNames) {
            sortedElements.push(colorantSet.get(name));
        }

        return sortedElements;
    };

    sortColorantByCanisterPosition = () => {
        /* eslint-disable-next-line no-undef */
        let canisterSet = new Map();
        let canisterPosition = [];

        if (this.props.loggedUser.canRead(resources.COMPONENT_CANISTERS_TAB) && this.props.allowCanisterColorants) {
            let canister;
            for (canister of this.props.canisterList) {
                canisterPosition.push(canister.name);
                canisterSet.set(canister.name, this.getColorantBox(canister));
            }
        } else {
            let colorant;
            for (colorant of this.props.colorantList) {
                canisterPosition.push(colorant.name);
                canisterSet.set(colorant.name, this.getColorantBox(null, colorant));
            }
        }

        let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: "base"});
        canisterPosition.sort(collator.compare);

        let sortedElements = [];
        let name;
        for (name of canisterPosition) {
            sortedElements.push(canisterSet.get(name));
        }

        return sortedElements;
    };

    getDefaultColorantBoxes = () => {
        let colorants = [];
        let colorantsNames = [];
        let colorantName;

        if (this.props.loggedUser.canRead(resources.COMPONENT_CANISTERS_TAB) && this.props.allowCanisterColorants) {
            let canister;
            for (canister of this.props.canisterList) {
                colorantName = canister.colorant !== null ? canister.colorant.name : "xyz" + canister.id;

                if (!colorantsNames.includes(colorantName)) {
                    colorantsNames.push(colorantName);
                    colorants.push(this.getColorantBox(canister));
                }
            }
        } else {
            let colorant;
            for (colorant of this.props.colorantList) {
                colorantName = colorant ? colorant.name : "xyz" + colorant.id;

                if (!colorantsNames.includes(colorantName)) {
                    colorantsNames.push(colorantName);
                    colorants.push(this.getColorantBox(null, colorant));
                }
            }
        }

        return colorants;
    };

    getColorantByCanister = (canister) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (canister.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return canister.colorant;
    };

    isColorantSelected = (colorantKey) => {
        if (this.props.selectedColorants.length === 0) {
            return false;
        }

        for (let selectedColorant of this.props.selectedColorants) {
            if (selectedColorant.id + "-" + selectedColorant.name === colorantKey) {
                return true;
            }
        }

        return false;
    };

    isDisabled = (colorantKey) => {
        if (this.props.activeDatabase === null || this.props.databaseColorantList === null) {
            return false;
        }

        for (let databaseColorant of this.props.databaseColorantList) {
            if (databaseColorant.id + "-" + databaseColorant.name === colorantKey) {
                return false;
            }
        }

        return true;
    };

    getColorantBox = (canister = null, cnt = null) => {
        let colorant;
        if (canister !== null && cnt === null) {
            colorant = canister.colorant !== null ? canister.colorant : null;
            if ((colorant === null || colorant.rgb === null) && canister.colorant !== null) {
                colorant = this.getColorantByCanister(canister);
            }
        } else {
            colorant = cnt;
        }

        if (colorant === null) {
            return "";
        }

        let colorantRgb = colorant.rgb === null ? config.DEFAULT_RGB : colorant.rgb;
        let colorantKey = colorant.id + "-" + colorant.name;

        if (this.isColorantSelected(colorantKey) || this.isDisabled(colorantKey)) {
            return (
                <div key={colorantKey} className="general-colorant-select-box disabled">
                    <div className="general-colorant-select-box-color" style={{backgroundColor: colorantRgb}} />
                    <div className="general-colorant-select-box-name">{colorant.displayName}</div>
                </div>
            );
        }

        return (
            <div
                key={colorantKey}
                className="general-colorant-select-box"
                data-id={colorantKey}
                onClick={this.props.handleSelectColorantClick}
            >
                <div
                    className="general-colorant-select-box-color"
                    style={{backgroundColor: colorantRgb}}
                    data-id={colorantKey}
                />
                <div className="general-colorant-select-box-name" data-id={colorantKey}>
                    {colorant.displayName}
                </div>
            </div>
        );
    };

    getColorantBoxes = () => {
        if (this.props.loggedUser.canRead(resources.COMPONENT_CANISTERS_TAB) && this.props.allowCanisterColorants) {
            if (this.props.canisterList.length === 0) {
                return (
                    <div className="no-available">
                        <Translate value="machineSettings.machineConfigurationNoCanisters" />
                    </div>
                );
            }
        } else {
            if (this.props.colorantList.length === 0) {
                return (
                    <div className="no-available">
                        <Translate value="general.noColorantsAvailable" />
                    </div>
                );
            }
        }

        if (this.props.sorting === settings.QUICK_TINT_SORTING_TYPE_ALPHA) {
            return this.sortColorantAlphabetically();
        }

        if (this.props.sorting === settings.QUICK_TINT_SORTING_TYPE_CANISTER) {
            return this.sortColorantByCanisterPosition();
        }

        return this.getDefaultColorantBoxes();
    };

    getPanelLabel = () => {
        if (this.props.activeDatabase === null) {
            if (this.props.spaceInPackage === null) {
                return null;
            }

            return (
                <React.Fragment>
                    <Translate value="general.addColorantForPackage" />:
                    <span className="color-black margin-left-10 font-size-0_75em bold">
                        {this.props.spaceInPackage.displayName}
                    </span>
                </React.Fragment>
            );
        }

        return <Translate value="customRedlike.addColorantFromBrand" brandName={this.props.activeDatabase.name} />;
    };

    render() {
        return (
            <div className="height-50per general-wrapper" {...this.props.elementProps}>
                <div className="general-wrapper-header">{this.getPanelLabel()}</div>
                <div className="general-wrapper-body slim-scroll general-colorant-select-box-wrapper">
                    {this.getColorantBoxes()}
                </div>
            </div>
        );
    }
}
